// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__3JQtc","password":"style_password__K6vFr","submit":"style_submit__3pA4y","floatleft":"style_floatleft__2SUCS","floatright":"style_floatright__WLZJC"};